import { generateQueryString, parseQueryString } from './queryString';

type ComposeImageSrcOptions = {
  size?: {
    width: number;
    height: number;
  };
  quality?: number;
  pathPrefix?: string;
  origin?: string;
};

export const composeImageSrc = (imageSrc: string, options?: ComposeImageSrcOptions) => {
  let newSrc = imageSrc.replace(/^\/\//, 'https://');

  if (!newSrc.includes('.gif')) {
    newSrc = newSrc.replace('/assets/', '/img/');
  }

  const newUrl = new URL(newSrc);

  const currentParams = parseQueryString(newUrl.search);

  const paramsObj = {
    ...(options?.size
      ? { h: options.size.height.toString(), w: options.size.width.toString(), operation: 'resize' }
      : {}),
    ...(options?.quality ? { q: options.quality.toString() } : {}),
    ...currentParams
  };

  const params = generateQueryString(paramsObj, {
    sort: (left, right) => left.localeCompare(right)
  });

  return `${options?.origin != null ? options.origin : newUrl.origin}${options?.pathPrefix || ''}${
    newUrl.pathname
  }${params ? `?${params}` : ''}`;
};
